(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ItensEstoqueCtrl', ItensEstoqueController);

  ItensEstoqueController.$inject = [
    '$scope',
    '$q',
    'LoadingService',
    'ItensEstoqueService',
    'GruposService',
    'AtividadesService',
    'UnidadesService',
    'MessagesService',
    '$location',
    'Flash',
    '$routeParams',
    '$route',
    'ItensService',
    '$filter'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function ItensEstoqueController($scope, $q, LoadingService,
    ItensEstoqueService, GruposService, AtividadesService,
    UnidadesService, MessagesService, $location,
    Flash, $routeParams, $route,
    ItensService, $filter) {
    const vm = this;
    const TIPO_INSUMO = 1;

    //////////////////////////////////////////
    // Controller data
    vm.products = [];
    vm.groups = [];
    vm.atividades = [];
    vm.items = [];
    vm.units = [];
    vm.balance = [];
    vm.loading = false;
    vm.createNew = false;
    vm.pages = {};
    vm.search = {
      descricao: '',
      grupo: null,
      exibir: 'all'
    };

    //////////////////////////////////////////
    // Bindable methods
    vm.columnClass = columnClass;
    vm.openEdit = openEdit;
    vm.setPage = setPage;
    vm.getItemBalance = getItemBalance;
    vm.isFiltering = isFiltering;
    vm.searchItems = searchItems;
    vm.clearFilters = clearFilters;
    vm.toggleItem = toggleItem;

    //////////////////////////////////////////
    // Function declarations

    function loadExtraData() {
      return $q.all([
        ItensEstoqueService.loadProducts(),
        GruposService.list(),
        AtividadesService.list(),
        UnidadesService.all()
      ])
        .then(([products, groups, atividades, units]) => {
          vm.products = products;
          vm.groups = groups.data.filter((group) => group.id[0] === TIPO_INSUMO);
          vm.atividades = atividades.data;
          vm.units = units.data;
        })
        .catch((error) => {
          console.error('Erro carregando dados', error);
          MessagesService.alert('Erro carregando dados, tente novamente.');
        });
    }

    function loadItemsBalance() {
      const ids = vm.items.map((product) => product.item_id).join(',');
      if (ids.length === 0) {
        return;
      }

      return ItensService.listItemsBalance({
        tipo_item: TIPO_INSUMO,
        all_depositos: true,
        item: ids
      })
        .then((result) => vm.balances = result.data)
        .catch((error) => {
          console.error('Erro carregando dados', error);
          MessagesService.alert('Falha ao carregar saldos de estoque.');
        });
    }

    function loadItems(complete = true) {
      vm.loading = true;
      vm.search = {
        descricao: $routeParams.descricao || '',
        grupo: ($routeParams.grupo && _.find(vm.groups, { id: [TIPO_INSUMO, +$routeParams.grupo] })) || null,
        exibir: $routeParams.exibir || 'all'
      };
      vm.items = [];
      vm.createNew = false;

      return ItensEstoqueService.load({ complete, filters: vm.search }, $routeParams.page)
        .then((response) => {
          vm.items = response.data;
          vm.items.forEach((item) => {
            item.produto = _.find(vm.products, { item_id: item.cd_produto });
          });
          vm.pages = response.pages;
          return loadItemsBalance();
        })
        .then(() => {
          vm.loading = false;
        })
        .catch((error) => {
          console.error('Erro ao carregar itens', error);
          MessagesService.alert('Erro ao carregar itens, tente novamente.');
          vm.loading = false;
        });
    }

    function columnClass() {
      if ($scope.$root.permissions.estoque.canViewStock) {
        return 'col-xs-4';
      }
      return 'col-xs-6';
    }

    function openEdit(index) {
      vm.items.forEach((item, i) => {
        if (i === index) {
          item.edit = true;
        } else {
          item.edit = false;
        }
      });
    }

    function setPage(page) {
      $route.updateParams({ page });
    }

    function getItemBalance(item) {
      const numberFilter = $filter('number');
      const balance = _.find(vm.balances, { id: item.item_id });
      if (balance) {
        const abreviatura = item.unidade.abreviatura.toLowerCase();
        return `
          ${numberFilter(balance.saldo_fisico, 2)} ${abreviatura} /
          ${numberFilter(balance.saldo_em_uso, 2)} ${abreviatura} /
          ${numberFilter(balance.saldo_receber, 2)} ${abreviatura}
        `;
      }
      return 'Indisp.';
    }

    function isFiltering() {
      return !!$routeParams.descricao || !!$routeParams.grupo;
    }

    function searchItems() {
      $route.updateParams({
        descricao: vm.search.descricao,
        grupo: vm.search.grupo && vm.search.grupo.id[TIPO_INSUMO],
        page: null,
        exibir: vm.search.exibir
      });
    }

    function clearFilters() {
      $route.updateParams({
        descricao: null,
        grupo: null,
        page: null,
        exibir: null
      });
    }

    function toggleItem(item) {
      LoadingService.showLoading();
      if (item.ativo) {
        deleteItem(item);
      } else {
        const promise = ItensEstoqueService.restoreItem(item);
        promise
          .then(() => MessagesService.alert('Item de estoque ativado com sucesso'))
          .then(() => loadItems())
          .catch((error) => {
            console.error(`Error ao ativar item ${item.descricao}`, error);
            MessagesService.alert('Erro ao ativar item de estoque');
          })
          .finally(LoadingService.hideLoading);
      }
    }

    function deleteItem(item) {
      MessagesService.confirm(`Você tem certeza que deseja inativar o item ${item.descricao}?`)
        .then(() => ItensEstoqueService.deleteItem(item))
        .then(() => MessagesService.alert('Item de estoque inativado com sucesso!'))
        .then(() => loadItems())
        .catch((error) => {
          console.error(`Error ao inativar item ${item.descricao}`, error);
          //eslint-disable-next-line
          if (typeof(error) !== typeof(undefined)) {
            MessagesService.alert('Erro ao atualizar item de estoque');
          }
        })
        .finally(LoadingService.hideLoading);
    }

    //////////////////////////////////////////
    // Controller logic
    const permissions = function() {
      if ($scope.$root.parametros.enable_sync_to_postgres && !$scope.$root.parametros.nao_cliente_agrogestao) {
        $scope.$root.permissions.itens_estoque.canManage = false;
      }
    };

    $scope.$root.bodyClass = 'gray-bg';
    LoadingService.showLoading();

    vm.loading = true;
    $scope.$root.initialize
      .then(() => {
        permissions();
        if (!$scope.$root.permissions.itens_estoque.canRead) {
          $location.path('/');
          Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
          return;
        }
        return loadExtraData();
      })
      .then(() => loadItems())
      .catch(() => $scope.$root.errorRootInitialize())
      .finally(() => LoadingService.hideLoading());

    // Eventos do editor
    $scope.$on('cancelCreate', () => vm.createNew = false);
    $scope.$on('cancelEdit', (event, item) => item.edit = false);
    $scope.$on('itemUpdated', (event, item, result) => {
      result.produto = _.find(vm.products, { item_id: result.cd_produto });
      vm.items[vm.items.indexOf(item)] = result;
    });
    $scope.$on('itemCreated', () => loadItems());

    // Eventos da rota
    $scope.$on('$routeUpdate', () => loadItems());
  }
}());
